// extracted by mini-css-extract-plugin
export default {"amount":"styles_amount__qkj+U","amount__title":"styles_amount__title__1muFv","amount__value":"styles_amount__value__aWPjN"};